<!--
    描述：左侧菜单
    时间：2020-04-15
    Created by ws
-->
<template>
    <div class="w-left-menu">
        <el-scrollbar wrap-class="scrollbar-wrapper">
            <el-menu
                mode="vertical"
                text-color="#fff"
                background-color="#304156"
                :default-active="activeMenu"
                @select="handleClick"
                :collapse="isCollapse"
                class="w-menu"
            >
                <!-- 一级 -->
                <template v-for="(item, index) in menuList">
                    <el-submenu
                        v-if="item.children && filterChildren(item.children).length > 0"
                        :index="item.name"
                        class="w-menu"
                    >
                        <template slot="title">
                            <svg-icon :icon-class="item.icon ? item.icon : ''" />
                            <span class="ml10 font-12">{{ item.meta.title }}</span>
                        </template>
                        <!-- 二级 -->
                        <template v-for="(m, n) in filterChildren(item.children)">
                            <el-submenu
                                v-if="m.children && filterChildren(m.children).length > 0"
                                :key="'menu.children' + n"
                                :index="m.name"
                            >
                                <template slot="title">
                                    <svg-icon :icon-class="m.icon ? m.icon : ''" />
                                    <span class="ml10 font-12">{{ m.meta.title }}</span>
                                </template>

                                <!--三级菜单-->
                                <el-menu-item
                                    v-for="(m1, index) in filterChildren(m.children)"
                                    :index="m1.name"
                                    :key="'last' + index"
                                >
                                    <svg-icon :icon-class="m1.icon ? m1.icon : ''" />
                                    <span slot="title" class="font-12">{{ m1.meta.title }}</span>
                                </el-menu-item>
                            </el-submenu>
                            <el-menu-item
                                v-else
                                :key="'menu.children' + n"
                                :index="m.name"
                            >
                                <svg-icon :icon-class="m.icon ? m.icon : ''" />
                                <span class="ml10 font-12">{{ m.meta.title }}</span>
                            </el-menu-item>
                        </template>
                    </el-submenu>

                    <el-menu-item :index="item.name" v-else class="w-menu-item">
                        <svg-icon :icon-class="item.icon ? item.icon : ''" />
                        <span class="ml10" slot="title">{{ item.meta.title }}</span>
                    </el-menu-item>
                </template>
            </el-menu>
        </el-scrollbar>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    data() {
        return {};
    },
    methods: {
        // 菜单点击事件
        handleClick(index, indexPath) {
            let _path;
            let _index = this.routeList.findIndex((x) => x.name === index);

            if (_index > -1) {
                // 如果是当前菜单
                if (index === this.$route.name) {
                    _path = "/redirect" + this.routeList[_index].path;
                } else {
                    _path = this.routeList[_index].path;
                }

                this.$router.push({
                    path: _path,
                });
            }
        },

        // children 过滤
        filterChildren(list) {
            let backArr = list.filter((x) => !x.hidden);
            return backArr;
        },
    },
    computed: {
        ...mapState("app", {
            isCollapse: (state) => state.isCollapse,
        }),
        ...mapState("menu", {
            activeRoutes: (state) => state.activeRoutes,
            routeList: (state) => state.routeList,
        }),
        // 当前菜单
        activeMenu() {
            const route = this.$route;
            const { name } = route;

            return name;
        },
        // 菜单列表
        menuList() {
            let arr = this.activeRoutes.find((x) => x.name === "Main");

            return arr.children.filter((x) => !x.hidden);
        },
    },
};
</script>

<style lang="less">
.w-left-menu {
    // @bgColor: #86eaea;
    @bgColor: #304156;
    // @bgColor: #016ca4;
    @hoverColor: #263445;
    @activeColor: #409eff;

    height: 100%;
    overflow: hidden;
    background-color: @bgColor;
    border-right: 1px solid @bgColor;

    .el-scrollbar {
        height: 100%;

        .scrollbar-wrapper {
            overflow-x: hidden;
        }
    }

    .el-menu {
        border: none;
        height: 100%;
        width: 100% !important;
        background-color: @bgColor;
    }

    .el-submenu__title {
		// padding: 0 15px !important;
        &:hover {
            background-color: @hoverColor;
        }
    }

    .el-submenu {
        @sub-bg-color: #1f2d3d;

        .el-menu {
            background-color: @sub-bg-color;
        }

        .el-menu-item {
            background-color: @sub-bg-color;
        }

        .el-menu-item:hover {
            background-color: #001528;
        }
    }

    .w-menu-item {
        height: 50px;
        line-height: 50px;
		margin: 5px 0;
		font-size: 12px;

        &:hover,
        &:active {
            background-color: @hoverColor;
        }
    }

    .w-menu-item.is-active {
        color: @activeColor;
	}
	
	.font-12 {
		font-size: 12px !important;
	}
}
</style>
